export default __webpack_public_path__ + "static/media/import.72a0ad84.svg";